<template>
  <div id="documenting">
    <div v-show="editProject === 'projectList'">
      <projectTable :operateColumns="operateColumns" ref="projectTable" :extraQuery="extraQuery" :extraSearch="extraSearch"></projectTable>
    </div>
    <div v-show="editProject === 'documenting'">
      <edit-project @back="backList" :projectData="projectData" :bidFileUrl="bidFileUrl"></edit-project>
    </div>
    <div v-show="editProject === 'createArticle'">
      <articles @back="backList" :projectData="projectData"></articles>
    </div>
    <div v-show="editProject === 'createMeeting'">
      <roomIndex @back="editProject='projectList'" :projectData="projectData"></roomIndex>
    </div>
  </div>
</template>

<script>
import editProject from './editProject'
import articles from './articles/articles'
import roomIndex from '../room/roomIndex'
import projectTable from '@/components/projectTable'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
import { getProjectPermission } from "@/lib/projectPermission"
import requestUrls from '@/lib/requestUrls'

export default {
  name: 'documenting',
  data() {
    return {
      operateColumns: [
        {
          title: '客户经理',
          key: 'am',
          width: 90
        },
        {
          title: '项目助理',
          key: 'aid',
          width: 90
        },
        {
          title: '报名截止日期',
          key: 'applyEnd',
          width: 118,
          render: (h, params) => {
            if (params.row.applyEnd) {
              return h('div', params.row.applyEnd.split('T')[0])
            }
          }
        },
        {
          title: '跟进人员',
          key: 'merchandiser',
          width: 90
        },
        {
          title: '操作',
          align: 'center',
          width: 280,
          render: (h, params) => {
            let disabled = true
            if (params.row.projectState === '审查通过可挂网' || params.row.projectState === '已挂网文件售卖中' || params.row.projectState === '开评标中') {
              disabled = false
            }
            return h('div', {
              style: {
                textAlign: 'center'
              }
            }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '10px'
                  },
                  on: {
                    click: () => {
                      this.bidFileUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=文件汇总/main2.cpt&op=write&NPID=${params.row.id}`
                      this.documentThis(params.row)
                    }
                  }
                }, '文件编制'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: disabled
                  },
                  style: {
                    marginRight: '10px'
                  },
                  on: {
                    click: () => {
                      this.createArticle(params.row)
                    }
                  }
                }, '公告挂网'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      // this.$Message.error('暂不能使用')
                      // return
                      this.createMeeting(params.row)
                    }
                  }
                }, '会议室预约'),
              ])
          }
        }
      ],
      editProject: 'projectList',
      projectData: {},
      // 项目状态筛选
      extraQuery: {
        status: ' and (projectState == "预立项" or projectState == "等待用户需求" or projectState == "文件编制中" or projectState == "标书文件已完成"  or projectState == "审查通过可挂网" or projectState == "已挂网文件售卖中" or projectState == "开评标中")',
        rolePermission: '',
        specialPermission: true
      },
      extraSearch: {
        searchManager: true
      },
      bidFileUrl: ''
    }
  },
  components: {
    editProject,
    articles,
    roomIndex,
    projectTable,
  },
  watch: {
    '$route'() {
      if (this.$route.name === 'documenting' && this.editProject === 'projectList') {
        this.$refs.projectTable.refreshProject()
      }
    }
  },
  methods: {
    documentThis(project) {
      this.projectData = project
      this.editProject = 'documenting'
    },
    createArticle(project) {
      this.projectData = project
      this.editProject = 'createArticle'
    },
    createMeeting(project) {
      this.projectData = project
      if (this.projectData.dataSource === '4.0立项') {
				this.$Modal.confirm({
					title: '温馨提示',
					content: '会议室预约功能已转移到采联业务系统4.0，请前往采联业务系统4.0处理。',
					cancelText: '取消',
					okText: '立即前往',
					onOk: () => {
						if (isWeiXin()) {
							window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
						} else {
							window.open('https://qy.choicelink.cn:8440')
						}
					}
				})
				return
			}
      this.editProject = 'createMeeting'
    },
    backList() {
      this.editProject = 'projectList'
      // 刷新列表
      this.$refs.projectTable.refreshProject()
    }
  }
}
</script>

<style lang="less" scoped>
#documenting {
  .search-wrapper {
    margin: 5px;
    .search {
      display: inline-block;
      margin-right: 5px;
      margin-bottom: 5px;
    }
  }
}
</style>
